import React from 'react'
import { Popover, OverlayTrigger } from 'react-bootstrap'

export function StatusBadges({ status, direction = 'row' }) {
  const flexDirection = direction === 'row' ? '' : 'flex-column'
  const badgeFamily = { ok: 'success', error: 'danger', neutral: 'neutral' }

  return (
    <div className={`d-flex ${flexDirection}`}>
      {status.map(item => {
        return (
          <div key={item.text}>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="bottom"
              overlay={<Popover id=''>{item.helpText}</Popover>}
            >
              <span
                className={`me-badge-tint me-badge-tint-${
                  badgeFamily[item.status]
                } mx-2 my-auto`}
              >
                {item.text}
              </span>
            </OverlayTrigger>
          </div>
        )
      })}
    </div>
  )
}
